import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'ds-checkbox-group',
  template: `
    <div class="checkbox-group-container" [class.inline]="to.inline">
      <div
        *ngFor="
          let option of to.options | formlySelectOptions: field | async;
          let i = index
        "
        class="checkbox-group-item"
      >
        <label [for]="id + '_' + i" class="checkbox-group-label">
          <input
            type="checkbox"
            [id]="id + '_' + i"
            [formlyAttributes]="field"
            [checked]="isChecked(option)"
            [disabled]="formControl.disabled || option.disabled"
            (change)="onChange(option.value, $event.target.checked)"
            class="checkbox-group-input"
          />
          <span class="checkbox-group-text">{{ option.label }}</span>
        </label>
      </div>
    </div>
  `,
  styles: [
    `
      .checkbox-group-container {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      .checkbox-group-container.inline {
        flex-flow: row wrap;
        gap: 16px;
      }
      .checkbox-group-item {
        display: flex;
        align-items: center;
        margin-inline-start: 4px;
      }
      .checkbox-group-label {
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        margin-bottom: 0;
      }
      .checkbox-group-input {
        cursor: pointer;
        margin: 0;
      }
      .checkbox-group-text {
        user-select: none;
      }
    `,
  ],
})
export class CheckboxGroupComponent extends FieldType {
  isChecked(option: any): boolean {
    const value = this.formControl.value;
    if (!value || !Array.isArray(value)) {
      return false;
    }
    return value.includes(option.value);
  }

  onChange(value: any, checked: boolean) {
    const currentValues = Array.isArray(this.formControl.value)
      ? [...this.formControl.value]
      : [];
    if (checked) {
      if (!currentValues.includes(value)) {
        currentValues.push(value);
      }
    } else {
      const index = currentValues.indexOf(value);
      if (index > -1) {
        currentValues.splice(index, 1);
      }
    }
    this.formControl.setValue(currentValues);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
    if (this.to.change) {
      this.to.change(this.field);
    }
  }
}
